import { isLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { getRetailer } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getRetailer";
import { getSessionCountry } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getSessionCountry";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import { ILocaleKey } from "@faire/web-api--source/indigofair/locale/ILocaleKey";
import { THREE_LETTER_PRIMARY_COUNTRY_CODES } from "@faire/web/common/consts/THREE_LETTER_PRIMARY_COUNTRY_CODES";
import { getLocaleKey } from "@faire/web/common/serialized-data/getLocaleKey";

export const shouldShowImprintPage = (): boolean => {
  const countryCode = isLoggedInRetailer()
    ? (getRetailer()?.country as keyof typeof ISO3166Alpha3)
    : getSessionCountry();

  return getShouldShowImprintPageFromCountryAndLocale(
    countryCode,
    getLocaleKey()
  );
};

export const getShouldShowImprintPageFromCountryAndLocale = (
  country: keyof typeof ISO3166Alpha3 | undefined,
  localeKey: ILocaleKey | undefined
): boolean => {
  return (
    country === THREE_LETTER_PRIMARY_COUNTRY_CODES.DEU &&
    localeKey?.language === Language.DEU
  );
};
